import * as Yup from "yup";

export const pointsScheme = Yup.object().shape({
  actionName: Yup.string().required("Please enter a title"),
  description: Yup.string().required("Please enter a description"),
  rewardPoints: Yup.string().required("Please enter a points"),
});
